import React from 'react';
import dayjs from 'dayjs';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import relativeTime from 'dayjs/plugin/relativeTime';
import clsx from 'clsx';

import type { IMessage } from 'src/services/api';
import { LeadUtils } from 'src/utils';
import { getMessageSenderName } from 'src/pages/landlord/leads/messages/components/messages-container/utils/get-message-sender-name';
import { EMessageDirection } from 'src/services/api';
import { Flex } from 'src/components/flex';
import { useLeadMessagesPageContext } from 'src/pages/landlord/leads/messages/context/hooks';
import MessageChannelBadge from 'src/pages/landlord/leads/messages/components/messages-container/MessageChannelBadge';

import styles from 'src/pages/landlord/leads/messages/components/messages-container/MessageHeader.module.css';

dayjs.extend(relativeTime);

type Props = {
    message: IMessage;
    isPlaceholder: boolean;
}

/**
 * This is the top part of the Message component
 */
export default function MessageHeader({ message, isPlaceholder}: Props) {
    const { lead, loggedInUser, teamMembers } = useLeadMessagesPageContext();
    const sentTime = dayjs(message.inserted_at).fromNow();

    let className;
    if (message.direction === 'out') {
        className = [styles.fromAgent];
    } else {
        className = [styles.fromLead];
    }

    return (
        <div className={styles.messageHeader + ' ' + className}>
            <div className={clsx(styles.name, 'ellipsisText')}>
                {message.direction === 'out' ? getMessageSenderName(message.owner, loggedInUser.id, teamMembers) : LeadUtils.getLeadName(lead)}
            </div>
            <Flex justifyContent="space-between" flexShrink={0}>
                {!isPlaceholder && (<span className={styles.sentTime}>{sentTime}</span>)}
                {message.direction === EMessageDirection.OUT && message.is_sent_by_automation && (
                    <span>
                        <span className={styles.desktopOnly}>sent by Reffie playbook</span>
                        <span className={styles.mobileOnly}>
                            <SmartToyOutlinedIcon className={styles.mobileOnly} />
                        </span>
                    </span>
                )}
                <MessageChannelBadge message={message} />
            </Flex>
        </div>
    );
}
